import axios from "axios";

const getDocuments = () =>
    axios
        .get("/content/document", {
            params: {
                ordering: "-published",
            },
        })
        .then((response) => response?.data || []);

const getDocument = async (id) => await axios.get(`/content/document/${id}`).then((response) => response.data);

const getDocumentPdf = async (id) => {
    const response = await axios.get(`/content/document/${id}/open`, {
        responseType: "arraybuffer",
    });
    return new Uint8Array(response.data);
};

const getArticles = (taxonomy = null, page_size = 500) =>
    axios
        .get("/content/article", {
            params: {
                page_size: page_size,
                taxonomy__slug: taxonomy,
                ordering: "-published",
                published__isnull: false,
            },
        })
        .then((response) => response?.data || []);

/** Every visible article's id, title and date, unpaginated: what an issue picker needs. */
const getArticleDates = (taxonomy = null) =>
    axios
        .get("/content/article/dates", {
            params: {
                taxonomy__slug: taxonomy,
                ordering: "-published",
                published__isnull: false,
            },
        })
        .then((response) => response?.data || []);

const getArticle = async (id) => await axios.get(`/content/article/${id}`).then((response) => response.data);

const getArticlePdf = async (id) => {
    const response = await axios.get(`/content/article/${id}/open`, {
        responseType: "arraybuffer",
    });
    return new Uint8Array(response.data);
};
export default {
    getDocuments,
    getDocument,
    getDocumentPdf,
    getArticles,
    getArticleDates,
    getArticle,
    getArticlePdf,
};
